import { getCurrentInstance, inject, type InjectionKey, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import { MATRIX_RETURN_FOLDER_QUERY } from '@/shared/lib';
import { MODULE_MATRIX_REVISION_ROUTE_NAME } from './useModuleMatrixRevisionScope';

// The revision page has no prefix in its route, so the matrix page hands its own down to the rows.
export const MATRIX_PAGE_PREFIX_KEY: InjectionKey<Ref<string>> = Symbol('matrixPagePrefix');

export function useMatrixPageOrigin() {
  const route = useRoute();
  const injectedPrefix = getCurrentInstance() ? inject(MATRIX_PAGE_PREFIX_KEY, null) : null;

  const prefix = (): string => injectedPrefix?.value ?? String(route.params.prefix ?? '');

  const returnQuery = (): { query?: Record<string, string> } => {
    const { folderCode } = route.params;
    if (route.name !== MODULE_MATRIX_REVISION_ROUTE_NAME || typeof folderCode !== 'string') {
      return {};
    }
    return { query: { [MATRIX_RETURN_FOLDER_QUERY]: folderCode } };
  };

  return { prefix, returnQuery };
}
